import React, { useState } from 'react'
import styles from './GroupSelector.module.css'

const GroupSelector = ({ groups, onSelect }) => {
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [selectedSubgroup, setSelectedSubgroup] = useState(null)
  const [selectedSubSubgroup, setSelectedSubSubgroup] = useState(null)
  const [selectedSubSubSubgroup, setSelectedSubSubSubgroup] = useState(null)

  const buildGroupPath = (
    group,
    subgroup = null,
    subSubgroup = null,
    subSubSubgroup = null
  ) => {
    let path = group
    if (subgroup) path += `-${subgroup}`
    if (subSubgroup) path += `-${subSubgroup}`
    if (subSubSubgroup) path += `-${subSubSubgroup}`
    return path
  }

  // Helper to truncate long names
  const truncate = (str) => (str.length > 25 ? str.slice(0, 25) + '...' : str)

  const handleGroupClick = (group, value) => {
    setSelectedGroup(group)
    setSelectedSubgroup(null)
    setSelectedSubSubgroup(null)
    setSelectedSubSubSubgroup(null)

    // If the value is not an object, it means it's a direct search value
    if (typeof value !== 'object') {
      onSelect(value, buildGroupPath(group))
    }
  }

  const handleSubgroupClick = (subgroup, value) => {
    setSelectedSubgroup(subgroup)
    setSelectedSubSubgroup(null)
    setSelectedSubSubSubgroup(null)

    // If the value is not an object, it means it's a direct search value
    if (typeof value !== 'object') {
      onSelect(value, buildGroupPath(selectedGroup, subgroup))
    }
  }

  const handleSubSubgroupClick = (subSubgroup, value) => {
    setSelectedSubSubgroup(subSubgroup)
    setSelectedSubSubSubgroup(null)

    // If the value is not an object, it means it's a direct search value
    if (typeof value !== 'object') {
      onSelect(
        value,
        buildGroupPath(selectedGroup, selectedSubgroup, subSubgroup)
      )
    }
  }

  const handleSubSubSubgroupClick = (subSubSubgroup, value) => {
    setSelectedSubSubSubgroup(subSubSubgroup)
    onSelect(
      value,
      buildGroupPath(
        selectedGroup,
        selectedSubgroup,
        selectedSubSubgroup,
        subSubSubgroup
      )
    )
  }

  return (
    <div className={styles.groupSelectorContainer}>
      <div className={styles.groupsList}>
        {Object.entries(groups).map(([group, value]) => (
          <div
            key={group}
            className={`${styles.groupItem} ${
              selectedGroup === group ? styles.selected : ''
            }`}
            onClick={() => handleGroupClick(group, value)}
          >
            {truncate(group)}
            {typeof value === 'object' && (
              <span className={styles.arrow}>›</span>
            )}
          </div>
        ))}
      </div>
      {selectedGroup && typeof groups[selectedGroup] === 'object' && (
        <div className={styles.subgroupsList}>
          {Object.entries(groups[selectedGroup]).map(([subgroup, value]) => (
            <div
              key={subgroup}
              className={`${styles.subgroupItem} ${
                selectedSubgroup === subgroup ? styles.selected : ''
              }`}
              onClick={() => handleSubgroupClick(subgroup, value)}
            >
              {truncate(subgroup)}
              {typeof value === 'object' && (
                <span className={styles.arrow}>›</span>
              )}
            </div>
          ))}
        </div>
      )}
      {selectedSubgroup &&
        typeof groups[selectedGroup][selectedSubgroup] === 'object' && (
          <div className={styles.subgroupsList}>
            {Object.entries(groups[selectedGroup][selectedSubgroup]).map(
              ([subSubgroup, value]) => (
                <div
                  key={subSubgroup}
                  className={`${styles.subgroupItem} ${
                    selectedSubSubgroup === subSubgroup ? styles.selected : ''
                  }`}
                  onClick={() => handleSubSubgroupClick(subSubgroup, value)}
                >
                  {truncate(subSubgroup)}
                  {typeof value === 'object' && (
                    <span className={styles.arrow}>›</span>
                  )}
                </div>
              )
            )}
          </div>
        )}
      {selectedSubSubgroup &&
        typeof groups[selectedGroup][selectedSubgroup][selectedSubSubgroup] ===
          'object' && (
          <div className={styles.subgroupsList}>
            {Object.entries(
              groups[selectedGroup][selectedSubgroup][selectedSubSubgroup]
            ).map(([subSubSubgroup, value]) => (
              <div
                key={subSubSubgroup}
                className={`${styles.subgroupItem} ${
                  selectedSubSubSubgroup === subSubSubgroup
                    ? styles.selected
                    : ''
                }`}
                onClick={() => handleSubSubSubgroupClick(subSubSubgroup, value)}
              >
                {truncate(subSubSubgroup)}
              </div>
            ))}
          </div>
        )}
    </div>
  )
}

export default GroupSelector
